<template>
  <div class="wrapper bg-dark-blue">
    <parallax class="section page-header header-filter" :style="headerStyle"></parallax>
    <div class="main main-raised">
      <div class="section section-basic">
        <div class="container">
          <div class="md-layout">
            <div class="md-layout-item md-size-50 mx-auto">
              <div class="md-layout-item text-center">
                <h2 class="title text-center">CATÁLOGO</h2>
              </div>
            </div>
          </div>
          
          <div class="md-layout">
            <div class="md-layout-item md-size-20 md-xsmall-size-100">
              <h4 class="text-center">Origem</h4>
              <a href="#/descricaoLivro">
                <img src="https://images.livrariasaraiva.com.br/imagemnet/imagem.aspx/?pro_id=9731880&qld=90&l=430&a=-1=1005874488" alt="Rounded Image" class="rounded img-livros">
              </a>
            </div>

            <div class="md-layout-item md-size-20 md-xsmall-size-100">
              <h4 class="text-center">O Homem De Giz</h4>
              <a href="#/descricaoLivro">
                <img src="https://images.livrariasaraiva.com.br/imagemnet/imagem.aspx/?pro_id=10109811&qld=90&l=430&a=-1=1005166356" alt="Rounded Image" class="rounded img-livros">
              </a>
            </div>

            <div class="md-layout-item md-size-20 md-xsmall-size-100">
              <h4 class="text-center">O Labirinto De Fogo</h4>
              <a href="#/descricaoLivro">
                <img src="https://images.livrariasaraiva.com.br/imagemnet/imagem.aspx/?pro_id=10133789&qld=90&l=430&a=-1=1005337457" alt="Rounded Image" class="rounded img-livros">
              </a>
            </div>

            <div class="md-layout-item md-size-20 md-xsmall-size-100">
              <h4 class="text-center">Princesa Das Cinzas</h4>
              <a href="#/descricaoLivro">
                <img src="https://images.livrariasaraiva.com.br/imagemnet/imagem.aspx/?pro_id=10337422&qld=90&l=430&a=-1=1005879211" alt="Rounded Image" class="rounded img-livros">
              </a>
            </div>

            <div class="md-layout-item md-size-20 md-xsmall-size-100">
              <h4 class="text-center">Estou Atrás De Você</h4>
              <a href="#/descricaoLivro">
                <img src="https://images.livrariasaraiva.com.br/imagemnet/imagem.aspx/?pro_id=9864058&qld=90&l=430&a=-1=1004887141" alt="Rounded Image" class="rounded img-livros">
              </a>
            </div>
          </div>

          <div class="md-layout">
            <div class="md-layout-item md-size-20 md-xsmall-size-100">
              <h4 class="text-center">A Origem Das Espécies</h4>
              <a href="#/descricaoLivro">
                <img src="https://images.livrariasaraiva.com.br/imagemnet/imagem.aspx/?pro_id=7246326&qld=90&l=430&a=-1=1001435829" alt="Rounded Image" class="rounded img-livros">
              </a>
            </div>

            <div class="md-layout-item md-size-20 md-xsmall-size-100">
              <h4 class="text-center">O Orfanato da Srta...</h4>
              <a href="#/descricaoLivro">
                <img src="https://images.livrariasaraiva.com.br/imagemnet/imagem.aspx/?pro_id=9022040&qld=90&l=430&a=-1=1002908450" alt="Rounded Image" class="rounded img-livros">
              </a>
            </div>

            <div class="md-layout-item md-size-20 md-xsmall-size-100">
              <h4 class="text-center">A Revolução Dos Bichos</h4>
              <a href="#/descricaoLivro">
                <img src="https://images.livrariasaraiva.com.br/imagemnet/imagem.aspx/?pro_id=1574783&qld=90&l=430&a=-1=1005808113" alt="Rounded Image" class="rounded img-livros">
              </a>
            </div>

            <div class="md-layout-item md-size-20 md-xsmall-size-100">
              <h4 class="text-center">A Sutil Arte De Ligar O...</h4>
              <a href="#/descricaoLivro">
                <img src="https://images.livrariasaraiva.com.br/imagemnet/imagem.aspx/?pro_id=9875730&qld=90&l=430&a=-1=1004909753" alt="Rounded Image" class="rounded img-livros">
              </a>
            </div>

            <div class="md-layout-item md-size-20 md-xsmall-size-100">
              <h4 class="text-center">Laranja Mecânica</h4>
              <a href="#/descricaoLivro">
                <img src="https://images.livrariasaraiva.com.br/imagemnet/imagem.aspx/?pro_id=158643&qld=90&l=430&a=-1=1005889316" alt="Rounded Image" class="rounded img-livros">
              </a>
            </div>
          </div>

          <div class="md-layout">
            <div class="md-layout-item md-size-20 md-xsmall-size-100">
              <h4 class="text-center">O Alquimista</h4>
              <a href="#/descricaoLivro">
                <img src="https://images.livrariasaraiva.com.br/imagemnet/imagem.aspx/?pro_id=9721873&qld=90&l=430&a=-1=1004097116" alt="Rounded Image" class="rounded img-livros">
              </a>
            </div>

            <div class="md-layout-item md-size-20 md-xsmall-size-100">
              <h4 class="text-center">O Demônio do Meio-Dia</h4>
              <a href="#/descricaoLivro">
                <img src="https://images.livrariasaraiva.com.br/imagemnet/imagem.aspx/?pro_id=7704926&qld=90&l=430&a=-1=1005806640" alt="Rounded Image" class="rounded img-livros">
              </a>
            </div>

            <div class="md-layout-item md-size-20 md-xsmall-size-100">
              <h4 class="text-center">O Diário de Anne Frank</h4>
              <a href="#/descricaoLivro">
                <img src="https://images.livrariasaraiva.com.br/imagemnet/imagem.aspx/?pro_id=347296&qld=90&l=430&a=-1=1005399083" alt="Rounded Image" class="rounded img-livros">
              </a>
            </div>

            <div class="md-layout-item md-size-20 md-xsmall-size-100">
              <h4 class="text-center">Fogo & Sangue</h4>
              <a href="#/descricaoLivro">
                <img src="https://images.livrariasaraiva.com.br/imagemnet/imagem.aspx/?pro_id=10501911&qld=90&l=430&a=-1=1005800629" alt="Rounded Image" class="rounded img-livros">
              </a>
            </div>

            <div class="md-layout-item md-size-20 md-xsmall-size-100">
              <h4 class="text-center">O Mínimo Que Você...</h4>
              <a href="#/descricaoLivro">
                <img src="https://images.livrariasaraiva.com.br/imagemnet/imagem.aspx/?pro_id=5093597&qld=90&l=430&a=-1=1005884378" alt="Rounded Image" class="rounded img-livros">
              </a>
            </div>
          </div>
          
          <div class="md-layout-item text-center mb-25">
            <md-button class="md-primary">Carregar Mais</md-button>
          </div>

        </div>
      </div>
    </div>
  </div>
</template>

<script>
import { Tabs } from "@/mk/components";
export default {
  components: {
    Tabs
  },
  bodyClass: "profile-page",
  data() {
    return {
      tabPane1: [
        { image: require("@/assets/img/examples/studio-1.jpg") },
        { image: require("@/assets/img/examples/studio-2.jpg") },
        { image: require("@/assets/img/examples/studio-4.jpg") },
        { image: require("@/assets/img/examples/studio-5.jpg") }
      ],
      tabPane2: [
        { image: require("@/assets/img/examples/olu-eletu.jpg") },
        { image: require("@/assets/img/examples/clem-onojeghuo.jpg") },
        { image: require("@/assets/img/examples/cynthia-del-rio.jpg") },
        { image: require("@/assets/img/examples/mariya-georgieva.jpg") },
        { image: require("@/assets/img/examples/clem-onojegaw.jpg") }
      ],
      tabPane3: [
        { image: require("@/assets/img/examples/mariya-georgieva.jpg") },
        { image: require("@/assets/img/examples/studio-3.jpg") },
        { image: require("@/assets/img/examples/clem-onojeghuo.jpg") },
        { image: require("@/assets/img/examples/olu-eletu.jpg") },
        { image: require("@/assets/img/examples/studio-1.jpg") }
      ]
    };
  },
  props: {
    header: {
      type: String,
      default: require("@/assets/img/bg-dark4.jpg")
    },
    img: {
      type: String,
      default: require("@/assets/img/faces/christian.jpg")
    }
  },
  computed: {
    headerStyle() {
      return {
        backgroundImage: `url(${this.header})`
      };
    }
  }
};
</script>

<style lang="scss" scoped>
.section {
  padding: 0;
}

.profile-tabs /deep/ {
  .md-card-tabs .md-list {
    justify-content: center;
  }

  [class*="tab-pane-"] {
    margin-top: 3.213rem;
    padding-bottom: 50px;

    img {
      margin-bottom: 2.142rem;
    }
  }
}

.mb-25{
  margin-bottom: 25px;
}

.bg-dark-blue{
  background-color: #000405 !important;
}
</style>
